module.exports = __webpack_public_path__ + "static/img/video-8.dd4cbdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-8.jpg
// module id = Jtqg
// module chunks = 12